import {
  Component,
  AfterViewInit,
  Renderer2,
  ChangeDetectorRef,
  HostListener,
  Input,
  ViewChild,
  ElementRef,
} from '@angular/core';
import * as fabric from 'fabric';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CardEditorService } from './card-editor.service';
import { HTTPService } from 'src/app/services/http.service';
import { forkJoin, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
import { LoginComponent } from '../Login/Login.component';
import { Router } from '@angular/router';
import { FooterService } from 'src/app/footer.service';

@Component({
  selector: 'app-card-editor',
  templateUrl: 'card-editor.component.html',
  styleUrls: ['card-editor.component.scss'],
})
export class CardEditorComponent implements AfterViewInit {
  @ViewChild('editTextbox') popupTextarea!: ElementRef<HTMLTextAreaElement>; // Reference textarea by id
  languages: string[] = ['English', 'Hindi', 'Marathi', 'Gujarati', 'Punjabi'];
  fonts: string[] = [];
  fontSizes: string[] = [
    '11px',
    '12px',
    '13px',
    '14px',
    '16px',
    '18px',
    '20px',
    '24px',
    '30px',
    '36px',
    '42px',
    '48px',
    '54px',
    '60px',
    '66px',
    '72px',
    '78px',
    '84px',
    '90px',
    '96px',
    '102px',
    '108px',
  ];
  selectedFont: string = 'Open Sans'; // Default font
  selectedFontSize: string = '16px'; // Default font size
  defaultTextColor: string = '#000000'; // Default text color
  selectedColor: string = '#000000'; // Default selected color
  isDropdownOpen = false;
  activeButton: string = '';
  isLoading = true;
  markerCoordinates: { x: number; y: number } | null = null;
  @Input() projectConfig: any = '{}';
  @Input() isAdmin: boolean = false;
  @Input() currentCard: any;
  showWatermarkPopup: boolean = false;
  canvasImage: string = '';
  singleFileList: any = [];
  userDetails: any = {};
  generatedOriginalImagePath: string = '';
  userCardId: number = 0;
  subscription = new Subscription();
  cardId = 0;
  generatedPlaceholderImagePath: string = '';
  promises = [];
  fontData: any;
  @ViewChild('fontFamilyDropdown') fontFamilyDropdown!: ElementRef;
  @ViewChild('fontFamilyDropdownMobile', { static: false }) fontFamilyDropdownMobile!: ElementRef;
  lastTapTime: number;

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  lineHeights: number[] = [1, 1.2, 1.5, 1.8, 2, 2.5, 3]; // Available line height options
  selectedLineHeight: number = 1; // Default line height
  isLabelVisible: boolean = true;

  // Track duplicate button position
  duplicateButtonPosition: { left: number; top: number; visible: boolean } = {
    left: 0,
    top: 0,
    visible: false,
  };

  deleteButtonPosition: { left: number; top: number; visible: boolean } = {
    left: 0,
    top: 0,
    visible: false,
  };




  closeDropdown() {
    this.isDropdownOpen = false;
  }

  onDownloadWithWatermark() {
    this.openWatermarkPopup();
    this.closeDropdown();
  }

  onDownloadPaid() {
    this.downloadPaid();
    this.toggleDropdown();
    this.closeDropdown();
  }
  private bootstrapScript!: HTMLScriptElement;
  constructor(
    public canvasService: CardEditorService,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
    private _httpService: HTTPService,
    public toastr: ToastrService,
    public sharedService: SharedService,
    private ngbModel: NgbModal,
    private _router: Router,
    private footerService: FooterService,
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'card-remove-body-padding');
    window.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Delete') {
        this.canvasService.deleteSelectedObject();
      }
    });
    console.log(`ng on init`);
    //const isMobile = window.innerWidth <= 768;
    const isMobile = screen.width <= 768;
    console.log(`screen.width <= 768 ${screen.width}`);
    this.canvasService.updateMobileViewStatus(isMobile);
    // console.log(`Device detection: isMobile: ${isMobile}`);
    // Subscribe to the isLoading$ observable
    this.canvasService.isLoading$.subscribe((loading) => {
      this.isLoading = loading;
    });

    
    // Subscribe to textbox bounds for duplicate button
    this.canvasService.selectedTextboxBounds$.subscribe((bounds) => {
      if (bounds && this.canvasService.canvas) {
        const canvasElement = this.canvasService.canvas.getElement();
        const canvasRect = canvasElement.getBoundingClientRect();
        const zoom = this.canvasService.canvas.getZoom();
        this.duplicateButtonPosition = {
          left: canvasRect.left + (bounds.left + bounds.width + 10) * zoom,
          top: canvasRect.top + (bounds.top - 30) * zoom,
          visible: true,
        };
        this.deleteButtonPosition = {
          left: canvasRect.left + (bounds.left + bounds.width + 40) * zoom,
          top: canvasRect.top + (bounds.top - 30) * zoom,
          visible: true,
        };
      } else {
        this.duplicateButtonPosition.visible = false;
        this.deleteButtonPosition.visible = false;
      }
      this.cd.detectChanges();
    });

    this.bootstrapScript = document.createElement('script');
    this.bootstrapScript.src =
      'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js';
    this.bootstrapScript.async = true;
    document.body.appendChild(this.bootstrapScript);


    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css';
    link.id = 'bootstrap5-scoped';

    // Optional: Load only if not already loaded
    if (!document.getElementById('bootstrap5-scoped')) {
      this.elementRef.nativeElement.prepend(link);
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'card-remove-body-padding');
    this.footerService.toggleFooterVisibility(true);
    this.footerService.toggleHeaderVisibility(true);
    if (this.bootstrapScript) {
      document.body.removeChild(this.bootstrapScript);
    }
  }
  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent): void {
  //   if (!(event.target as HTMLElement).closest('.dropdown')) {
  //     this.isDropdownOpen = false;
  //   }
  // }
  //   ngAfterViewInit(): void {
  //     try {
  //         console.log(`ngAfterViewInit`);

  //         // Initialize the canvas with a loader
  //         this.canvasService.initializeCanvasWithLoader('canvas');

  //         if (this.projectConfig == "{}") {
  //             console.log('New Project, No config exists');
  //             this.canvasService.canvasConfig = '1';
  //             this.canvasService.hideImageUploaderImage();
  //         } else {
  //             console.log('Existing Project-->', this.projectConfig);
  //             // Load canvas configuration synchronously
  //             this.canvasService.loadCanvasConfig('assets/card-assets/Magical_butterflies.json').subscribe(data => {
  //                 this.canvasService.canvasConfig = this.projectConfig.CardMain;
  //                 console.log('Canvas Config Loaded:', this.canvasService.canvasConfig);

  //                 const isMobile = screen.width <= 768;
  //                 this.canvasService.updateMobileViewStatus(isMobile);
  //                 this.canvasService.setUpCanvas();

  //                 const rect = this.canvasService.addRectToCanvas(this.canvasService?.canvasConfig);
  //                 const uploader = document.getElementById('image-uploader') as HTMLElement;
  //                 this.canvasService.initializeUploaderPositioning();

  //                 if (!isMobile) {
  //                     this.canvasService.scaleCanvasToViewport();
  //                     window.addEventListener('resize', () => this.canvasService.scaleCanvasToViewport());
  //                 }

  //                 this.setupCanvasEventListeners();
  //             });
  //         }

  //         // Load fonts synchronously and update UI
  //         this.canvasService.loadFontsJson('assets/card-assets/fonts.json').subscribe(fontsData => {
  //             const fontsList = fontsData.templates[0].fonts;
  //             this.canvasService.applyFonts(fontsList);
  //             this.fonts = fontsList.map((fontUrl: string) =>
  //                 fontUrl.split('=')[1].split('&')[0].replace('+', ' ')
  //             );
  //         });
  //     } catch (error) {
  //         console.error('Error in ngAfterViewInit:', error);
  //         this.canvasService.hideLoader();
  //     }
  // }

  // setupCanvasEventListeners(): void {
  //     this.canvasService.canvas?.on('mouse:out', (event) =>
  //         this.canvasService.handleMouseOut(event as unknown as fabric.TPointerEvent)
  //     );
  //     this.canvasService.canvas?.on('selection:created', (event) =>
  //         this.canvasService.handleSelectionCreated(event as fabric.TEvent)
  //     );
  //     this.canvasService.canvas?.on('selection:updated', (event) =>
  //         this.canvasService.handleSelectionUpdated(event as fabric.TEvent)
  //     );
  //     this.canvasService.canvas?.on('selection:cleared', () =>
  //         this.canvasService.handleSelectionCleared()
  //     );
  //     this.canvasService.canvas?.on('mouse:over', (event) =>
  //         this.canvasService.handleMouseOver(event as unknown as fabric.TPointerEvent)
  //     );
  //     this.canvasService.canvas?.on('object:modified', (event) =>
  //         this.canvasService.handleObjectModified(event as any)
  //     );

  //     this.renderer.listen('document', 'click', (event: MouseEvent) => {
  //         this.canvasService.handleOutsideClick(event);
  //     });
  // }

  async ngAfterViewInit(): Promise<void> {
    try {
      // Initialize the canvas with a loader
      await this.canvasService.initializeCanvasWithLoader('canvas');

      // Fetch project JSON path synchronously
      // const projectJsonPath = await this.canvasService.GetProjectConfig('123456734').toPromise();
      // console.log('Resolved JSON Path:', projectJsonPath);

      if (this.projectConfig == '{}') {
        // console.log('New Project, No config exists');
        this.canvasService.canvasConfig = '1';
        this.canvasService.hideImageUploaderImage();
        
      } else {
        this.canvasService.canvasConfig = this.projectConfig.CardMain;
        // console.log('Canvas Config Loaded:', this.canvasService.canvasConfig);

        // Setup canvas
        const isMobile = screen.width <= 768;

        this.canvasService.updateMobileViewStatus(isMobile);
        this.canvasService.setUpCanvas();

        //console.log('addRectToCanvas');
        // Add the Fabric object for the uploader
        const rect = this.canvasService.addRectToCanvas(
          this.canvasService?.canvasConfig
        );
        const uploader = document.getElementById(
          'image-uploader'
        ) as HTMLElement;
        this.canvasService.initializeUploaderPositioning();
        if (!isMobile) {
          //Apply initial scaling
          this.canvasService.scaleCanvasToViewport();
          // Resize canvas dynamically on window resize
          window.addEventListener('resize', () =>
            this.canvasService.scaleCanvasToViewport()
          );
        }
        
      }

      // Add event listeners for hover and selection behavior
      // this.canvasService.canvas?.on('mouse:move', (event) =>
      //   this.canvasService.handleMouseMove(event as fabric.TEvent)
      // );

      this.canvasService.canvas?.on('mouse:out', (event) =>
        this.canvasService.handleMouseOut(
          event as unknown as fabric.TPointerEvent
        )
      );

      this.canvasService.canvas?.on('selection:created', (event) => {
        this.canvasService.handleSelectionCreated(event as fabric.TEvent);
        this.syncControls();
      }
      );
      this.canvasService.canvas?.on('selection:updated', (event) => {
        this.canvasService.handleSelectionUpdated(event as fabric.TEvent);
        this.syncControls();
      }
      );
      this.canvasService.canvas?.on('selection:cleared', () => {
        this.canvasService.handleSelectionCleared();
        this.resetControls();
      }
      );

      this.canvasService.canvas?.on('mouse:over', (event) =>
        this.canvasService.handleMouseOver(
          event as unknown as fabric.TPointerEvent
        )
      );
      this.canvasService.canvas?.on(
        'object:modified',
        (event) => this.canvasService.handleObjectModified(event as any) // Cast to 'any' to bypass strict typing
      );

      this.canvasService.canvas?.on('object:moving', (event) =>
        this.canvasService.handleObjectMoving(event as any)
      );

      (this.canvasService.canvas as any).on('mouse:down', (e: any) => {
        if (!this.canvasService.isMobileView || !e.target || e.target.type !== 'textbox') return;

        const currentTime = new Date().getTime();
        const tapLength = currentTime - this.lastTapTime;

        if (tapLength < 300 && tapLength > 0) {
          // console.log('Double-tap triggered on mobile');
      
          const textbox = e.target as fabric.Textbox;
          const text = textbox.text || '';
          const textAlign = textbox.textAlign || 'left';

          this.canvasService.selectedTextbox = textbox;
          this.canvasService.openTextEditPopup({ text, textAlign });
        }

        this.lastTapTime = currentTime;
      });


      // Add an event listener to document to handle clicks outside the canvas and controls
      this.renderer.listen('document', 'click', (event: MouseEvent) => {
        this.canvasService.handleOutsideClick(event);
      });



      // Load fonts synchronously and update UI
      const fontsData = await this.canvasService
        .loadFontsJson('assets/card-assets/fonts.json')
        .toPromise();
      const fontsList = fontsData.templates[0].fonts;
      this.canvasService.applyFonts(fontsList);
      this.fonts = fontsList.map((fontUrl: string) =>
        fontUrl.split('=')[1].split('&')[0].replace('+', ' ')
      );
      this.addFontStyling();


    } catch (error) {
      console.error('Error in ngAfterViewInit:', error);
      this.canvasService.hideLoader();
    }
  }


  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
      this.copyTextboxFormatting();
    }
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'v') {
      event.preventDefault();
      this.pasteTextboxFormatting();
    }
    if (event.ctrlKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      this.duplicateTextbox();
    }
    if (event.key === 'Delete') {
      event.preventDefault();
      this.deleteSelectedObject();
    }
  }
   // New method to copy formatting
   copyTextboxFormatting(): void {
    this.canvasService.copyTextboxFormatting();
  }

  // New method to paste formatting
  pasteTextboxFormatting(): void {
    this.canvasService.pasteTextboxFormatting();
  }

  duplicateTextbox(): void {
    const clonedTextbox = this.canvasService.duplicateTextbox();
    if (clonedTextbox) {
      
    } else {
     
    }
  }

  private syncControls(): void {
    // console.log('syncControls called');
    if (this.canvasService.selectedTextbox) {
      // Log values to verify they're set
      // console.log('Syncing controls with:', {
      //   font: this.canvasService.selectedFont,
      //   size: this.canvasService.selectedFontSize,
      //   color: this.canvasService.selectedColor,
      //   bold: this.canvasService.isBold,
      //   italic: this.canvasService.isItalic,
      //   alignLeft: this.canvasService.isAlignLeft,
      //   alignCenter: this.canvasService.isAlignCenter,
      //   alignRight: this.canvasService.isAlignRight,
      // });

      // Explicitly update component properties
      this.selectedFont = this.canvasService.selectedFont || 'Open Sans';
      this.selectedFontSize = this.canvasService.selectedFontSize || '16px';
      this.selectedColor = this.canvasService.selectedColor || '#000000';
      this.isBoldActive = this.canvasService.isBold ?? false;
      this.isItalicActive = this.canvasService.isItalic ?? false;
      this.selectedLineHeight = this.canvasService.selectedLineHeight || 1; // Add line height

      if (this.canvasService.isAlignLeft) {
        this.activeTextButton = 'left';
      } else if (this.canvasService.isAlignCenter) {
        this.activeTextButton = 'center';
      } else if (this.canvasService.isAlignRight) {
        this.activeTextButton = 'right';
      }

      // Force change detection
      this.cd.detectChanges();

      // Additional log to confirm component state
      // console.log('Component state after sync:', {
      //   selectedFont: this.selectedFont,
      //   selectedFontSize: this.selectedFontSize,
      //   selectedColor: this.selectedColor,
      //   isBoldActive: this.isBoldActive,
      //   isItalicActive: this.isItalicActive,
      //   activeTextButton: this.activeTextButton,
      // });
    }
  }
  // Reset controls when selection is cleared
  private resetControls(): void {
    this.selectedFont = 'Open Sans';
    this.selectedFontSize = '16px';
    this.selectedColor = '#000000';
    this.isBoldActive = false;
    this.isItalicActive = false;
    this.activeTextButton = 'left';
    this.selectedLineHeight = 1; // Reset line height
    this.cd.detectChanges();
  }


  @HostListener('window:resize', [])
  onResize() {
    const isMobile = window.innerWidth <= 768;
    this.canvasService.updateMobileViewStatus(isMobile);
  }

  onLineHeightChange(event: Event): void {
    const lineHeight = parseFloat((event.target as HTMLSelectElement).value);
    this.selectedLineHeight = lineHeight; // Update selected line height
    this.canvasService.applyLineHeight(lineHeight);
    this.isLabelVisible = !this.selectedLineHeight;
  }


  onFontChange(event: Event): void {
    //this.canvasService.addText();
    const font = (event.target as HTMLSelectElement).value;
    this.selectedFont = font; // Update selected font
    this.canvasService.applyFontStyle(font, this.selectedFontSize);
  }

  onFontSizeChange(event: Event): void {
    const fontSize = (event.target as HTMLSelectElement).value;
    this.selectedFontSize = fontSize; // Update selected font size
    this.canvasService.applyFontStyle(this.selectedFont, fontSize);
  }

  addText(): void {
    this.canvasService.addText();
  }

  updateTextboxColor(event: any): void {
    this.canvasService.updateTextboxColor(event);
  }

  uploadImage(event: any): void {
    this.canvasService.uploadImage(event);
  }

  addImageToCanvas(event: any): void {
    this.canvasService.addImageToCanvas(event);
  }

  loadLanguageElements(event: any): void {
    this.canvasService.loadLanguageElements(event);
  }

  isBoldActive: boolean = false;
  isItalicActive: boolean = false;

  toggleBold(): void {
    this.isBoldActive = !this.isBoldActive;
    // console.log('isBoldActive:', this.isBoldActive); // ✅ Check if it logs correctly
    this.canvasService.toggleBold();
  }

  toggleItalic(): void {
    this.isItalicActive = !this.isItalicActive;
    this.canvasService.toggleItalic();
  }
  activeTextButton: string = 'left';
  alignText(align: string): void {
    this.activeTextButton = align;
    this.canvasService.alignText(align);
  }

  deleteSelectedObject(): void {
    this.canvasService.deleteSelectedObject();
    this.cd.detectChanges();
  }

  downloadAsPNGWithBackgroundReplacement(): void {
    this.canvasService.downloadAsPNGWithBackgroundReplacement(
      this.currentCard.originalImageURL
    );
  }
  getBase64BasedOnBackgroundImage() {
    this.canvasService
      .getBase64WithBackgroundReplacement(this.currentCard.originalImageURL)
      .then((data: any) => { });
  }
  downloadAsPNG(): void {
    this.canvasService.downloadAsPNG();
  }

  saveJSON(): void {
    const updatedJSON = this.canvasService.generateUpdatedJSON();

    const dataStr =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(JSON.stringify(updatedJSON, null, 2));

    const downloadAnchor = document.createElement('a');
    downloadAnchor.href = dataStr;
    downloadAnchor.download = 'card-config.json';
    downloadAnchor.click();
  }
  onSaveTextChanges() {
    this.canvasService.applyTextChanges();
  }

  onCancelTextEdit() {
    this.canvasService.closeTextEditPopup();
  }

  // openTextEditPopup() {
  //   this.canvasService.openTextEditPopup();
  // }

  openTextEditPopup(): void {
    const activeObject = this.canvasService.getActiveObject();
    if (activeObject && activeObject.type === 'textbox') {
      const textbox = activeObject as fabric.Textbox; // Cast to fabric.Textbox
      const text = textbox.text || '';
      const textAlign = textbox.textAlign || 'left';
      this.canvasService.openTextEditPopup({ text, textAlign });
    }
  }

  onBackgroundUpload(event: any): void {
    const file = event.target.files[0];
    if (file) {
      // Pass the File object directly to the service method
      this.canvasService.uploadBackgroundImage(file);
    } else {
      console.error('No file selected or file input is invalid.');
    }
  }

  onPhotoUpload(event: any): void {
    const file = event.target.files[0];
    if (file) {
      // Pass the File object directly to the service method
      this.canvasService.uploadPhoto(file);
    } else {
      console.error('No file selected or file input is invalid.');
    }
  }

  getPhotoCoordinates(): void {
    const coords = this.canvasService.getPhotoCoordinates();
    alert(`Top: ${coords.top}, Left: ${coords.left}`);
  }
  addPlacementMarker(): void {
    this.canvasService.addPlacementMarker();
  }

  //Selected color to set for new template hover etc.
  onColorSelected(event: Event): void {
    const color = (event.target as HTMLInputElement).value; // Get the selected color
    // console.log('Selected color:', color); // Debugging
    this.canvasService.setSelectedColor(color); // Pass the color to the service
  }

  saveTemplate(): void {
    const validationMessage = this.canvasService.validateTemplate();
    if (validationMessage !== 'Ok') {
      alert(validationMessage);
      return;
    } else {
      const updatedJSON = this.canvasService.generateUpdatedTemplate();

      const dataStr =
        'data:text/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(updatedJSON, null, 2));

      const downloadAnchor = document.createElement('a');
      downloadAnchor.href = dataStr;
      downloadAnchor.download = 'card-config.json';
      downloadAnchor.click();
    }
  }

  // getCardState() {
  //   const validationMessage = this.canvasService.validateTemplate();
  //   if (validationMessage !== "Ok") {
  //     alert(validationMessage);
  //     return;
  //   }
  //   var currentState = this.canvasService.generateUpdatedTemplate();
  //   currentState.CardMain.Elements.filter(x => x.type == "image").filter(y => y.properties.base64 != null && y.properties.base64 != "").forEach(element => {
  //     let image = this.sharedService.base64ToBlob(element.properties.base64).blob;
  //     this.singleFileList = [];
  //     this.singleFileList.push({ "fieldName": "placeholder_", "file": image });
  //     let objRequestData = Object.assign({});
  //     this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
  //     objRequestData.UserId = (this.userDetails == null || this.userDetails == undefined) ? 0 : this.userDetails.UserId;
  //     let request = this._httpService.ajaxPostFileList('Personalize/UploadTemplateFile', this.singleFileList, objRequestData);
  //     this.promises.push(request);
  //   });
  //   this.processImageSave(currentState);
  // }
  // processImageSave(imageState: any) {
  //   let imageData = imageState.CardMain.Elements.filter(x => x.type == "image").filter(y => y.properties.base64 != null);
  //   forkJoin(this.promises).subscribe((data: any) => {
  //     data.forEach((value, index) => {
  //       imageData[index].properties.src = this._httpService.baseURL + value.FilePath;
  //       imageData[index].properties.base64 = null;
  //     });
  //     if (imageState.CardMain.Elements.filter(x => x.type == "image").filter(y => y.properties.Background == 1)[0].properties.src != "") {
  //       imageState.CardMain.imgsrc = imageState.CardMain.Elements.filter(x => x.type == "image").filter(y => y.properties.Background == 1)[0].properties.src;
  //     }
  //     return imageState;
  //   })
  // }

  getCardState(): Promise<any> {
    return new Promise((resolve, reject) => {
      const validationMessage = this.canvasService.validateTemplate();
      if (validationMessage !== 'Ok') {
        alert(validationMessage);
        return reject(validationMessage); // Reject the promise if validation fails
      }

      const currentState = this.canvasService.generateUpdatedTemplate();
      const imageElements = currentState.CardMain.Elements.filter(
        (x) => x.type === 'image'
      ).filter(
        (y) =>
          y.properties.base64 != null &&
          y.properties.base64 !== '' &&
          y.properties.Background != 1
      );

      this.promises = []; // Reset the promise list
      imageElements.forEach((element) => {
        let image = this.sharedService.base64ToBlob(
          element.properties.base64
        ).blob;
        this.singleFileList = [{ fieldName: 'placeholder_', file: image }];

        let objRequestData = Object.assign({});
        this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
        objRequestData.UserId = this.userDetails?.UserId || 0;

        let request = this._httpService.ajaxPostFileList(
          'Personalize/UploadTemplateFile',
          this.singleFileList,
          objRequestData
        );
        this.promises.push(request);
      });
      if (this.promises.length == 0) {
        resolve(currentState);
      }
      else {
        // Process images and resolve the final state
        forkJoin(this.promises).subscribe({
          next: (data: any[]) => {
            this.processImageSave(currentState, data);
            resolve(currentState);
          },
          error: (error) => {
            console.error('Error uploading images:', error);
            reject(error);
          },
        });
      }
    });
  }
  processImageSave(imageState: any, uploadResults: any[]) {
    let imageData = imageState.CardMain.Elements.filter(
      (x) => x.type === 'image'
    ).filter((y) => y.properties.base64 != null);
    uploadResults.forEach((value, index) => {
      imageData[index].properties.src =
        this._httpService.baseURL + value.FilePath;
      imageData[index].properties.base64 = null;
    });

    const backgroundImage = imageState.CardMain.Elements.find(
      (x) => x.type === 'image' && x.properties.Background === 1
    );
    if (backgroundImage?.properties.src) {
      imageState.CardMain.imgsrc = backgroundImage.properties.src;
    }
  }
  openWatermarkPopup(): void {
    this.canvasImage = this.canvasService.getCanvasImage() ?? ''; // Get image from service
    this.showWatermarkPopup = true;
  }
  downloadFree(): void {
    this.canvasService.downloadAsPNG();
  }
  closeWatermarkPopup(): void {
    this.showWatermarkPopup = false;
  }
  saveDraft(isPaidDownLoad: boolean = false) {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));

    if (this.userDetails == null || this.userDetails == undefined) {
      const modelRef = this.ngbModel.open(LoginComponent, {
        size: 'lg',
        windowClass: 'login-dialog',
      });
      this.sharedService.isShowLoader.next(false);
      modelRef.result.then((data: any) => {
        if (data && isPaidDownLoad) {
          this.sharedService.isShowLoader.next(true);
          this.processSaveOrDownloadCard(isPaidDownLoad);
        }
      })
      return;
    }
    this.processSaveOrDownloadCard(isPaidDownLoad);
  }
  private processSaveOrDownloadCard(isPaidDownLoad: boolean) {
    this.getCardState().then((cardState: any) => {
      console.log(cardState);
      let waterMarkImage = this.canvasService.getBase64WithBackgroundReplacement(
        environment.baseURL + this.currentCard.PlaceholderImage
      );
      let originalImage = this.canvasService.getBase64WithBackgroundReplacement(
        environment.baseURL + this.currentCard.OriginalImage
      );
      this.promises = [];
      this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
      this.promises.push(waterMarkImage);
      this.promises.push(originalImage);
      forkJoin(this.promises).subscribe({
        next: (data: any[]) => {
          this.promises = [];
          data.forEach((element) => {
            let image = this.sharedService.base64ToBlob(element).blob;
            this.singleFileList = [{ fieldName: 'placeholder_', file: image }];

            let objRequestData = Object.assign({});

            objRequestData.UserId = this.userDetails?.UserId || 0;

            let request = this._httpService.ajaxPostFileList(
              'Personalize/UploadTemplateFile',
              this.singleFileList,
              objRequestData
            );
            this.promises.push(request);
          });

          // Process images and resolve the final state
          forkJoin(this.promises).subscribe({
            next: (data: any[]) => {
              this.userDetails = JSON.parse(
                localStorage.getItem('userDetails')
              );

              let objSave = Object.assign({});
              objSave.UserCardId = this.userCardId;
              objSave.UserId =
                this.userDetails == null || this.userDetails == undefined
                  ? 0
                  : this.userDetails.UserId;
              objSave.CardId = this.currentCard.CardId;
              objSave.PlaceholderImagePath = data[0].FilePath;
              objSave.OriginalImagePath = data[1].FilePath;
              objSave.CardStatus = 3;
              let backgroundImage = cardState.CardMain.Elements.filter(
                (x) => x.type === 'image' && x.properties.Background == 1
              )[0];
              backgroundImage.properties.base64 = null;
              objSave.ImageState = JSON.stringify(cardState);
              this.subscription.add(
                this._httpService
                  .ajaxPost('Personalize/AddUpdateUserCardDetail', objSave)
                  .subscribe((data: any) => {
                    if (data.UserCardId > 0) this.userCardId = data.UserCardId;
                    if (isPaidDownLoad) {
                      this.sharedService.isShowLoader.next(true);
                      let objLog = Object.assign({});
                      objLog.UserId = this.userDetails?.UserId;
                      objLog.MethodName = 'Pay & Download Card';
                      objLog.IsSuccess = true;
                      objLog.Description = 'User clicked pay & download card';
                      objLog.IPAddress = this.sharedService.ipAddress;
                      let encryptedqueryparams: { userCardId: any; };

                      encryptedqueryparams = {
                        userCardId: this.userCardId,
                      };
                      this.subscription.add(
                        this._httpService
                          .ajaxPost('Personalize/AddLog', objLog)
                          .subscribe((data) => {
                            this.sharedService.isShowLoader.next(false);
                            this._router.navigate([
                              `/userpayment/${this.currentCard.Description}/${this.sharedService.encryptData(
                                JSON.stringify(encryptedqueryparams)
                              )}`,
                            ]);
                          })
                      );
                    } else {
                      this.toastr.success('Card generated successfully!!!');
                    }
                    this.sharedService.isShowLoader.next(false);
                  })
              );
            },
            error: (error) => {
              this.sharedService.isShowLoader.next(false);
              console.error('Error uploading images:', error);
            },
          });
        },
        error: (error) => {
          this.sharedService.isShowLoader.next(false);
          console.error('Error uploading images:', error);
        },
      });
    });
  }

  uploadImageNew(file: any, isOriginalImage: boolean) { }
  downloadPaid() {
    this.sharedService.isShowLoader.next(true);
    this.saveDraft(true);
  }
  removeWatermark() {
    this.sharedService.isShowLoader.next(true);
    this.saveDraft(true);
  }
  fontList: string[] = [];
  selectedFont1: string = '';

  addFontStyling(language: string = 'english'): void {
    if (language === 'english') {
      this.fontData = this.sortFontsByName(this.customFonts);
    }
    else if (language === 'hindi') {
      this.fontData = this.customFonts_Hindi;
    }
    else if (language === 'tamil') {
      this.fontData = this.customFonts_Tamil;
    }
    else if (language === 'marathi') {
      this.fontData = this.customFonts_Marathi;
    }
    else if (language === 'telugu') {
      this.fontData = this.customFonts_Telugu;
    }
    else if (language === 'gujarati') {
      this.fontData = this.customFonts_Gujarati;
    }
    else if (language === 'arabic') {
      this.fontData = this.customFonts_Arabic;
    }
    else if (language === 'kannada') {
      this.fontData = this.customFonts_Kannada;
    }
    else {
      this.fontData = this.customFonts[`customFonts_${language}`];
    }
    this.fontList = Object.keys(this.fontData);
    // let container: HTMLElement;
    // container = this.fontFamilyDropdown.nativeElement;
    // container.innerHTML = '';
    // for (const font in this.fontData) {
    //   const fontName = document.createElement('p');
    //   fontName.setAttribute('data-family', font);
    //   fontName.style.fontFamily = font;
    //   fontName.innerHTML = font;
    //   container.append(fontName);
    // }
    // let containerMobile: HTMLElement;
    // containerMobile = this.fontFamilyDropdownMobile.nativeElement;
    // containerMobile.innerHTML = '';
    // for (const font in this.fontData) {
    //   const fontName = document.createElement('p');
    //   fontName.setAttribute('data-family', font);
    //   fontName.style.fontFamily = font;
    //   fontName.innerHTML = font;
    //   containerMobile.append(fontName);
    // }
  }
  onFontChange1(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.selectedFont1 = target.value;
    // Apply font somewhere or emit value
    console.log('Selected font:', this.selectedFont1);
  }
  sortFontsByName(fonts: { [key: string]: string[] }): { [key: string]: string[] } {
    return Object.fromEntries(
      Object.entries(fonts).sort(([a], [b]) => a.localeCompare(b))
    );
  }
  customFonts = {
    "Arial": ["Regular", "Bold", "Italic", "BoldItalic"],
    "Baby Girly Script": ["Regular"],
    "Ananda Black Personal Use": ["Regular"],
    "Lato": ["Regular", "BlackItalic", "Bold", "BoldItalic"],
    "Amellinda Weddings": ["Regular"],
    "Calibri": ["Regular", "Bold", "BoldItalic", "Light"],
    "Cardo": ["Regular", "Italic", "Bold"],
    "Golden Hills DEMO": ["Regular"],
    "LEMON MILK": ["Regular", "Bold", "BoldItalic"],
    "Poppins": ["Regular", "Bold", "BoldItalic"],
    "Gotham Black": ["Regular"],
    "GROBOLD": ["Regular"],
    "Kitten Swash": ["Regular"],
    "Honey Florist - Personal Use": ["Regular"],
    "Trajan Pro": ["Regular"],
    "Kaushan Script": ["Regular"],
    "Goudy Old Style": ["Regular", "Bold", "ITALIC"],
    "Candlescript Demo Version": ["Regular"],
    "GoudyTitling-Bold": ["Regular"],
    "Anydore": ["Regular"],
    "RaniscriptW00-Regular": ["Regular"],
    "Kitten Slant": ["Regular"],
    "ShangriLaNF": ["Regular"],
    "Infinite Stroke": ["Regular"],
    "Dandeleon Vintage Demo": ["Regular"],
    "Montserrat": ["Regular", "Bold", "MediumBold", "BlackItalic"],
    "Monya Unguta": ["Regular"],
    "Brighton": ["Regular", "Rough"],
    "Cease-Fire 1": ["Regular"],
    "Brock Script": ["Regular"],
    "Copperplate Gothic Bold": ["Regular"],
    "Copperplate Gothic Light": ["Regular"],
    "Kunstler Script": ["Regular"],
    "Adobe Caslon Pro": ["Regular", "Semibold"],
    "DickensScriptSSK": ["Regular"],
    "Butler": ["Regular", "UltraLight", "Light", "Bold", "ExtraBold", "Black", "MediumBold"],
    "Billion Dreams": ["Regular"],
    "Birch Std": ["Regular"],
    "Boomer Tantrum": ["Regular"],
    "Carnivalee Freakshow": ["Regular"],
    "Nunito": ["Regular", "Black", "Bold", "BoldItalic", "MediumBold"],
    "Pictorial Signature": ["Regular"],
    "Tw Cen MT Condensed Extra Bold": ["Regular"],
    "Mistic": ["Regular"],
    "Master Of Break": ["Regular"],
    "Quiska": ["Regular"],
    "Microsoft Himalaya": ["Regular"],
    "Futuristic Stylish": ["Regular"],
    "Californian FB": ["Regular", "Bold", "Italic"],
    "Century Schoolbook": ["Regular"],
    "BODIDLYbold": ["Regular"],
    "Chock A Block NF": ["Regular"],
    "Bungasai": ["Regular"],
    "ALS Script": ["Regular"],
    "Neocyr": ["Regular"],
    "Nyala": ["Regular"],
    "Cormorant Upright": ["Bold", "MediumBold", "SemiBold"],
    "Comic Sans MS": ["Regular", "Bold", "Italic"],
    "Baskerville Old Face": ["Regular"],
    "Satisfy": ["Regular"],
    "Plantagenet Cherokee": ["Regular"],
    "Palatino Linotype": ["Regular", "Bold", "BoldItalic"],
    "Algerian": ["Regular"],
    "Guttever Bold": ["Regular"],
    "GoodVibrations": ["Regular"],
    "ITC Benguiat Std Book": ["Regular"],
    "Agoda": ["Regular"],
    "Alex Brush": ["Regular"],
    "Josefin Sans": ["Regular", "Light", "Bold"],
    "Bite Chocolate": ["Regular"],
    "Amperzand": ["Regular"],
    "Courgette": ["Regular"],
    "Bluebell": ["Regular"],
    "Ebrima": ["Regular", "Bold"],
    "Baskerville BT": ["Roman", "Bold"],

    "BlackChancery": ["Regular"],
    "Alegreya": ["Regular", "Bold", "Italic"],
    "Gabriola": ["Regular"],
    "Averia Serif": ["Regular", "Bold"],
    "Baloo Bhai 2": ["Regular"],
    "Cambria": ["Regular", "Bold", "Italic"],
    "Arbutus Slab": ["Regular"],
    "Aladin": ["Regular"],

    "Berkshire Swash": ["Regular"],
    "Darleston": ["Regular"],
    "Myriad Pro": ["Regular"],
    "Constantia": ["Regular", "Bold", "Italic"],
    "Amiri": ["Regular", "Bold"],
    "Castellar": ["Regular"],
    "Pioggia": ["Regular"],
    "Abril Fatface": ["Regular"],

    "Abhaya Libre": ["Regular"],
    "Stay In Villa": ["Regular"],
    "Anthony Hunter": ["Regular"],
    "Playfair Display": ["Black", "Bold", "BoldItalic"],
    "Parisienne": ["Regular"],
    "Londrina Solid": ["Regular"],
    "Sriracha": ["Regular"],
    "Sacramento": ["Regular"],
    "Yellowtail": ["Regular"],
    "Baskerville": ["Regular"],
    "Jungle Adventurer": ["Regular"],
    "Amatic SC": ["Regular", "Bold"],
    "TimeBurner": ["Regular"],
    "Reliable DEMO": ["Regular"],
    "Kaisei Opti": ["Regular"],
    "Amsterdam Signature": ["Regular"],
    "Adulatory": ["Regular"],
    "Pacifico": ["Regular"],
    "Mullingar": ["Regular"],
    "Candyful": ["Regular"],
    "Luckiest Guy": ["Regular"],
    "Britannic Bold": ["Regular"],

    "Grand Hotel": ["Regular"],
    "Alista Script": ["Regular"],
    "Allrounder Monument Test": ["Regular"],
    "Acme": ["Regular"],
    "Barber Street_PersonalUseOnly": ["Regular"],
    "Cookie": ["Regular"],
    "Always Smile": ["Regular"],
    "PlaytimeWithHotToddiesOblique": ["Regular"],
    "Gochi Hand": ["Regular"],
    "Oh Whale": ["Regular"],
    "Nugelo": ["Regular"],
    "Mussica": ["Regular"],
    "Embassy BT": ["Regular"],
    "Caroni": ["Regular"],
    "Dancing Script": ["Regular", "MediumBold", "SemiBold", "Bold"],
    "Rochester": ["Regular"],

    "Frankfurter Std": ["Regular"],
    "Anja Eliane": ["Regular"],
    "Poor Richard": ["Regular"],
    "Feeling Lovely": ["Regular"],
    "Aclonica": ["Regular"],
    "High Tower Text": ["Regular"],

    "Airthay": ["Regular"],
    "Agenda King": ["Regular"],
    "Centaur": ["Regular"],
    "Amalina": ["Regular"],
    "Activists": ["Regular"],
    "Agency FB": ["Regular"],
    "Amsterdian": ["Regular"],
    "28 Days Later": ["Regular"],
    "Autography": ["Regular"],
    "Annabel 1": ["Regular"],
    "Aulyars": ["Regular"],
    "Beautiful People Personal Use": ["Regular"],
    "Anime": ["Regular"],
    "Sylfaen": ["Regular"],
    "Bodoni MT": ["Regular"],
    "UVF Mussica Swash": ["Regular"],
    "Nazelia Script": ["Regular"],
    "&Matchmaker": ["Regular"],
    "Felix Titling": ["Regular"],
    "Birmingham Script": ["Regular"],
    "Bollent": ["Regular"],
    "Bell MT": ["Regular"],
    "Happy-Dance": ["Regular"],
    "AMS Aaditya": ["Regular"],
    "Andasia Personal Use": ["Regular"],
    "Jokerman": ["Regular"],
    "El Messiri": ["Regular"],
    "Amarithe": ["Regular"],
    "Allura": ["Regular"],





  }

  customFonts_Hindi = {
    "Rozha One": ["Regular"],
    "Laila": ["Regular"],
    "Arya": ["Regular"],
    "Chanakya": ["Regular"],
    "Mangal": ["Regular"],
    "Kruti Dev 010": ["Regular"],
  }

  customFonts_Gujarati = {
    "Gujrati Saral-1": ["Regular"],
    "Rasa": ["Regular", "Bold", "MediumBold", "Italic"],
    "EKLG-01": ["Regular"],
    "EKLG-02": ["Regular"],
    "EKLG-05": ["Regular", "Bold"],
    "EKLG-06": ["Regular", "Bold"],
    "EKLG-07": ["Regular", "Bold"],
    "EKLG-08": ["Regular"],
    "EKLG-10": ["Regular"],
    "EKLG-13B": ["Regular"],
    "EKLG-19": ["Regular"],
    "EKLG-21": ["Regular"],
    "EKLG-24": ["Regular"],
    "EKLG-13": ["Regular", "Bold"],
    "EklG-14": ["Regular", "Bold"],
    "EKLG-20": ["Regular", "Bold"],
    "EKLG-23": ["Regular", "Bold"],
    "EKLG-27 Rinesh": ["Regular"],
    "EKLG-31 Rinesh": ["Regular"],
    "EKLG-45 Rinesh": ["Regular"],

    "EKLG-26 Rinesh": ["Regular", "Italic"],
    "EKLG-29 Rinesh": ["Regular", "Italic"],
    "EKLG-30 Rinesh": ["Regular", "Italic"],
    "EKLG-32 Rinesh": ["Regular", "Italic"],
    "EKLG-33 Rinesh": ["Regular", "Italic"],
    "EKLG-39 Rinesh": ["Regular", "Italic"],
    "EKLG-41 Rinesh": ["Regular", "Italic"],
    "EKLG-43 Rinesh": ["Regular", "Italic"],
    "EKLG-44 Rinesh": ["Regular", "Italic"],
    "EKLG-47 Rinesh": ["Regular", "Italic"],

  }

  customFonts_Tamil = {
    "SunTommy": ["Regular"],
    "VANAVIL-Avvaiyar": ["Regular"],
  }

  customFonts_Telugu = {
    "Ponnala": ["Regular"],
    "Potti Sreeramulu": ["Regular"],
  }

  customFonts_Marathi = {
    "AMS Aaditya": ["Regular"],
  }

  customFonts_Arabic = {
    "Baloo Bhaijaan": ["Regular"],
    "Jomhuria": ["Regular"],
    "Lateef": ["Regular"],
    "Mothanna": ["Regular", "Bold"],
    "Droid Arabic Kufi": ["Regular", "Bold"],
  }

  customFonts_Kannada = {
    "Nudi 17 e": ["Regular"],
    "Nudi 27 e": ["Regular"],
    "Nudi 01 e": ["Regular", "Bold"],
  }

  openDropDown(event: Event, subType: number): void {
    let ele = event.currentTarget as HTMLElement;
    const dropdown = ele.querySelector('div') as HTMLElement;
    const icon = ele.querySelector('i');

    // Get the button's position relative to the viewport
    const rect = ele.getBoundingClientRect();

    // Create a container for the dropdown if not already created
    let dropdownContainer = document.querySelector('.font-family-dropdown') as HTMLElement;
    if (!dropdownContainer) {
      dropdownContainer = document.createElement('div');
      dropdownContainer.classList.add('font-family-dropdown');
      document.body.appendChild(dropdownContainer); // Append to body or another container outside the toolbar
    }

    // Set the dropdown content only if it's empty
    if (!dropdownContainer.innerHTML && dropdown) {
      dropdownContainer.innerHTML = dropdown.innerHTML;
    }

    // Toggle dropdown visibility
    if (dropdownContainer.classList.contains('open')) {
      dropdownContainer.classList.remove('open');
      icon?.classList.replace('fa-angle-up', 'fa-angle-down');
    } else {
      dropdownContainer.classList.add('open');
      icon?.classList.replace('fa-angle-down', 'fa-angle-up');
    }

    // Get the height of the dropdown container (if needed for adjustment)
    const dropdownHeight = dropdownContainer.offsetHeight;

    // Check window width and position dropdown accordingly
    if (window.innerWidth < 768) {
      // For mobile: Position the dropdown above the button
      dropdownContainer.style.position = 'fixed';
      dropdownContainer.style.top = `${rect.top - dropdownHeight - 10}px`; // Above button
      dropdownContainer.style.left = `${rect.left}px`; // Align with left of the button
    } else {
      // For desktop: Position the dropdown below the button (or adjust for overflow)
      dropdownContainer.style.position = 'fixed';
      dropdownContainer.style.top = `${rect.top + rect.height + 10}px`; // Below button
      dropdownContainer.style.left = `${rect.left}px`; // Align with left of the button

      // Check if dropdown goes off-screen on the right
      if (dropdownContainer.getBoundingClientRect().right > window.innerWidth) {
        dropdownContainer.style.left = `${window.innerWidth - dropdownContainer.offsetWidth - 10}px`; // Adjust left
      }
    }

    if (subType == 1) this.handleFontFamily(event);
  }


  handleFontFamily(event: Event): void {
    const target = event.target as HTMLElement;
    let ele = event.currentTarget as HTMLElement;
    const selectedFontFamily = target.dataset['family'];

    if (!selectedFontFamily) return;

    // this.renderer.setStyle(
    //   this.currentSelectedText,
    //   'font-family',
    //   `'${selectedFontFamily}'`
    // );
    const font = selectedFontFamily;
    this.selectedFont = selectedFontFamily;
    this.canvasService.applyFontStyle(font, this.selectedFontSize);
    const familyText = ele.querySelector('p .data-family') as HTMLElement;
    if (familyText) {
      familyText.innerHTML = selectedFontFamily;
    }

    const fontElements = ele.querySelectorAll('.font-family-dropdown p, .mobile-fontfamily-display p');
    fontElements.forEach((element) => {
      this.renderer.removeClass(element, 'active');
    });

    this.renderer.addClass(target, 'active');

    // this.handleFontWeight('',
    //   document.querySelector('.font-style-container') as HTMLElement,
    //   'Regular');
  }





}
